<template>
  <v-container class="pa-2 page-layout" fluid>
    <v-menu
      v-if="(user.role === 'Superuser' || user.role === 'manager' || user.role === 'fmo') && !isFamilyHealthChoiceProvider"
      v-model="menu"
      :close-on-content-click="false"
      offset-x
      left
    >
      <template v-slot:activator="{ on }">
        <v-btn color="primary" right top fixed class="show-filters py-5 mt-15" v-on="on">
          <v-icon>mdi-filter-menu</v-icon>
        </v-btn>
      </template>
      <v-list class="py-0 pt-2" max-width="350px" min-width="350px">
        <template>
          <v-list-item>
            <v-select
              v-model="orgChoice"
              :items="organizations"
              :menu-props="{ maxHeight: '400' }"
              label="Organizations"
              outlined
              dense
              clearable
            >
              <template v-slot:selection="{ item, index }">
                <span>{{ item }}</span>
                <span v-if="index === 1" class="grey--text caption"
                  >+{{ orgChoice.length - 1 }}</span
                >
              </template>
            </v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="insChoice"
              :items="insurances"
              required
              :rules="[this.insChoice.length !== 0 || 'Insurance is required']"
              item-text="Insurance"
              return-object
              :menu-props="{ maxHeight: '400' }"
              label="Select Insurance"
              outlined
              dense
              clearable
              @click:clear="$nextTick(() => (insChoice = []))"
            ></v-select>
          </v-list-item>
          <v-list-item>
            <v-autocomplete
              v-model="groupChoice"
              :items="groups"
              item-text="GROUP_NAME"
              item-value="BILLING_PROVIDER_NPI"
              :menu-props="{ maxHeight: '400' }"
              label="Groups"
              multiple
              outlined
              dense
              clearable
              class="newSelect"
            >
              <template v-slot:selection="{ item, index }">
                <div class="selection-text" v-if="index === 0">{{ item.GROUP_NAME }}</div>
                <span v-if="index === 1" class="grey--text caption"
                  >+{{ groupChoice.length - 1 }}</span
                >
              </template>
            </v-autocomplete>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="provChoice"
              :items="providers"
              item-value="PROVIDER_ID"
              item-text="PROVIDER_NAME"
              :menu-props="{ maxHeight: '400' }"
              label="Providers"
              multiple
              clearable
              outlined
              dense
              class="newSelect"
            >
              <template v-slot:selection="{ item, index }">
                <div class="selection-text" v-if="index === 0">
                  {{ item.PROVIDER_NAME }}
                </div>
                <span v-if="index === 1" class="grey--text caption"
                  >+{{ provChoice.length - 1 }}</span
                >
              </template>
            </v-select>
          </v-list-item>
          <v-list-item>
            <v-select
              v-model="locChoice"
              :items="locations"
              item-text="SERVICE_LOCATION_NAME"
              return-object
              :menu-props="{ maxHeight: '400' }"
              label="Locations"
              multiple
              outlined
              dense
              clearable
              class="newSelect"
            >
              <template v-slot:selection="{ item, index }">
                <div class="selection-text" v-if="index === 0">
                  {{ item.SERVICE_LOCATION_NAME }}
                </div>
                <span v-if="index === 1" class="grey--text caption"
                  >+{{ locChoice.length - 1 }}</span
                >
              </template>
            </v-select>
          </v-list-item>
          <v-list-item>
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  label="Start Date"
                  show-current="2021-12"
                  append-icon="mdi-calendar"
                  outlined
                  dense
                  class="mt-5"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                :close-on-content-click="true"
                show-current="false"
                type="month"
                @input="menu1 = false"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-list-item>
          <v-list-item>
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  label="End Date"
                  append-icon="mdi-calendar"
                  outlined
                  dense
                  readonly
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                show-current="false"
                :close-on-content-click="true"
                type="month"
                @input="menu2 = false"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </v-list-item>
        </template>
        <v-list-item v-if="startDate > endDate">
          <v-alert class="error--text pa-0">Please use a valid date range</v-alert>
        </v-list-item>
        <v-list-item>
          <v-row justify="space-between">
            <v-btn text @click="close" color="error">Cancel</v-btn>
            <v-btn
              :disabled="startDate > endDate ? true : false"
              @click="getDashboard"
              text
              color="success"
              >Save</v-btn
            >
          </v-row>
        </v-list-item>
      </v-list>
    </v-menu>

    <div
      v-if="user.role === 'Superuser' || user.role === 'manager' || user.role === 'fmo' || user.role === 'Provider' || user.role === 'Specialist'"
      flat
      id="dashboard"
    >
      <v-row dense class="mb-3">
        <v-col class="py-0">
          <h1 class="page-title">Dashboard</h1>
        </v-col>
      </v-row>
      <!-- Cards (show only after loading data) -->
      <template v-if="!loading && cards.length > 0">
        <v-row class="pb-5">
          <v-col lg="3" md="6" sm="12" v-for="card in cards" :key="card.title">
            <v-card class="mx-auto" max-width="400" min-height="80">
              <div class="d-flex align-center">
                <img :src="card.icon" alt="icon" class="mr-6 ml-5" width="40" />
                <div class="mt-2">
                  <h4 class="text-subtitle-1 font-weight-light">{{ card.title }}</h4>
                  <h2 class="text-h6">{{ card.amount }}</h2>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-row align-content="center" justify="center" v-if="loading">
        <v-col cols="12" sm="6" md="4" lg="3" class="text-center">
          <v-progress-circular
            color="primary"
            :size="70"
            :width="5"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>

      <!-- Gráficos completos (apenas para não-FHC Provider) -->
      <div v-if="!loading && !isFamilyHealthChoiceProvider">
        <v-row class="pb-5 pt-5">
          <v-col cols="12" md="6" lg="8">
            <admissions-chart :chartData="admissionsData" />
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <brandRxCount
              :chartInfo="dashboardData ? dashboardData : null"
              :view="'dashboard'"
            />
          </v-col>
        </v-row>
      </div>
      
      <!-- Membership Roster (para todos) -->
      <div v-if="!loading && membershipData && membershipData.length > 0">
        <v-row class="pb-5 pt-5">
          <v-col class="py-0">
            <h3 class="page-title">Membership Roster</h3>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6" lg="4" class="pb-0">
            <v-text-field
              v-model="membershipSearch"
              label="Search Members"
              placeholder="Name or ID..."
              clearable
              outlined
              dense
              prepend-inner-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-card flat class="rounded-lg">
              <v-data-table
                :headers="membershipHeaders"
                :items="filteredMembershipData"
                :items-per-page="15"
                :footer-props="{ 'items-per-page-options': [10, 15, 25, 50, -1] }"
                :no-data-text="'No matching members...'"
                class="membership-table"
                dense
              >
                <template v-slot:item.NAME="{ item }">
                  <span class="font-weight-medium">{{ membershipName(item) }}</span>
                </template>
                <template v-slot:item.SUBSCRIBER_ID="{ item }">
                  <v-chip small outlined color="secondary">{{ item.SUBSCRIBER_ID || item._id || '—' }}</v-chip>
                </template>
                <template v-slot:item.DOB="{ item }">
                  {{ formatDate(item.DOB) || 'N/A' }}
                </template>
                <template v-slot:item.GENDER="{ item }">
                  {{ item.GENDER || '—' }}
                </template>
                <template v-slot:item.GROUP_NAME="{ item }">
                  {{ formatPlanName(item.GROUP_NAME || item.PLAN_NAME) || 'N/A' }}
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
      
      <!-- Message when no data is available -->
      <div v-if="!loading && (!membershipData || membershipData.length === 0)">
        <v-row class="pb-5 pt-5">
          <v-col cols="12">
            <v-alert type="warning">
              No membership data available for the selected period.
              <br><br>
              <strong>Data loaded:</strong> {{ membershipData ? membershipData.length : 0 }} members
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import membershipChart from '../components/dashboardCharts/membershipChart.vue';
import mraChart from '../components/dashboardCharts/mraChart.vue';
import mlrChart from '../components/dashboardCharts/mlrChart.vue';
import revenueChart from '../components/dashboardCharts/revenueChart.vue';
import admissionsChart from '../components/dashboardCharts/admissions.vue';
import admissionsCostChart from '../components/dashboardCharts/admissionsCost.vue';
import admitsPerChart from '../components/dashboardCharts/admitsPer1000.vue';
import averageStay from '../components/dashboardCharts/averageStay.vue';
import BrandRxCount from '../components/dashboardCharts/brandRxCount.vue';
import BrandRxCost from '../components/dashboardCharts/brandRxCost.vue';
import erCost from '../components/dashboardCharts/erCost.vue';
import ErVisitPer1000 from '../components/dashboardCharts/erVisitPer1000.vue';
import ErVisits from '../components/dashboardCharts/erVisits.vue';
import ExpensesChart from '../components/dashboardCharts/expensesChart.vue';
import gdrChart from '../components/dashboardCharts/gdrChart.vue';
import inpatientDaysPer1000 from '../components/dashboardCharts/inpatientDaysPer1000.vue';
import observationPer1000 from '../components/dashboardCharts/observationPer1000.vue';
import outpatientCost from '../components/dashboardCharts/outpatientCost.vue';
import outpatientVisits from '../components/dashboardCharts/outpatientVisits.vue';
import readmissions from '../components/dashboardCharts/readmissions.vue';
import totalInpatient from '../components/dashboardCharts/totalInpatient.vue';
import avatarIcon from '@/assets/icons/avatar.svg';
import MembershipReports from '../components/membershipComponents/MembershipReports.vue';
import { formatPlanNameForDisplay } from '../utils/planNameDisplay';

export default {
  name: 'Dashboard',
  components: {
    mraChart,
    MembershipReports,
    mlrChart,
    revenueChart,
    membershipChart,
    admissionsChart,
    admissionsCostChart,
    admitsPerChart,
    averageStay,
    BrandRxCost,
    erCost,
    gdrChart,
    inpatientDaysPer1000,
    observationPer1000,
    outpatientCost,
    outpatientVisits,
    BrandRxCount,
    ErVisits,
    ErVisitPer1000,
    ExpensesChart,
    readmissions,
    totalInpatient,
  },
  data() {
    return {
      loading: false,
      user: { role: '', insurance: [] }, // Inicializar com estrutura correta
      orgChoice: [],
      groupChoice: [],
      provChoice: [],
      organizations: [],
      groups: [],
      insurances: [],
      providers: [],
      locations: [],
      locChoice: [],
      insChoice: [],
      erCost: 0,
      erTotal: 0,
      admissionsCost: 0,
      admissionsTotal: 0,
      brandRx: 0,
      gdrAverage: 0,
      revenueTotal: 0,
      expensesTotal: 0,
      brandRxCount: 0,
      membership: 0,
      allRxCount: 0,
      outpatientVisit: 0,
      outpatientCost: 0,
      readmissions: 0,
      inpatients: 0,
      membershipData: [],
      dashboardData: '',
      admissionsData: null,
      csvData: '',
      cards: [], // Inicializar vazio, será preenchido dinamicamente
      membershipSearch: '',
      membershipHeaders: [
        { text: 'Name', value: 'NAME', sortable: true },
        { text: 'ID', value: 'SUBSCRIBER_ID', sortable: true },
        { text: 'DOB', value: 'DOB', sortable: true },
        { text: 'Sex', value: 'GENDER', sortable: true },
        { text: 'Plan', value: 'GROUP_NAME', sortable: true },
      ],
      menu: false,
      menu1: false,
      menu2: false,
      startDate: moment()
        .subtract(1, 'quarter')
        .startOf('quarter')
        .toISOString()
        .substring(0, 7),
      endDate: moment()
        .subtract(1, 'quarter')
        .endOf('quarter')
        .subtract(1, 'ms')
        .toISOString()
        .substr(0, 7),
    };
  },
  methods: {
    formatPlanName(val) {
      return formatPlanNameForDisplay(val);
    },
    async getUser() {
      console.log('🔍 Dashboard: getUser() called');
      await axios
        .get('/api/user')
        .then((response) => {
          this.user = response.data[0];
          console.log('✅ User loaded:', this.user.role, this.user.insurance);

          // check role and reroute if unauthorized
          this.checkPresets();
          
          console.log('🔍 After checkPresets - insChoice:', this.insChoice);
          
          // Para Provider/Specialist, sempre chamar getDashboard se tiver insurance
          if (this.user.role === 'Provider' || this.user.role === 'Specialist') {
            if (this.insChoice && this.insChoice.length > 0) {
              console.log('🔍 Auto-calling getDashboard for Provider/Specialist');
              this.getDashboard();
            } else {
              console.log('⚠️ insChoice is empty, cannot call getDashboard');
            }
          } else if (this.insChoice.length > 0) {
            console.log('🔍 Calling getDashboard for non-Provider role');
            this.getDashboard();
          }
        })
        .catch((error) => {
          console.error('❌ Error loading user:', error);
          this.$router.push('/login');
        });
    },
    checkPresets() {
      if (
        this.user.role === 'Clinical'
        || this.user.role === 'Provider'
        || this.user.role === 'Specialist'
        || this.user.role === 'Group'
        || this.user.role === 'Affiliation'
      ) {
        this.setPresets();
      } else {
        this.getOrgs();
        this.getInsurances();
      }
    },
    setPresets() {
      if (this.user.role === 'Group') {
        this.organizations = [this.user.organization];
      } else {
        this.organizations = this.user.organization;
        this.insurances = this.user.insurance;
      }
      this.groups = this.user.group;
      this.insurances = this.user.insurance;

      if (this.user.role === 'Provider' || this.user.role === 'Clinical') {
        this.insChoice = this.user.insurance[0];
        this.orgChoice = this.user.organization;
        
        // Limpar arrays com strings vazias
        this.groupChoice = (this.user.group && this.user.group.filter(g => g && g.trim() !== '')) || [];
        this.location = (this.user.location && this.user.location.filter(l => l && l.trim() !== '')) || [];
        
        // Adicionar NPI aos providers
        if (this.user.npi) {
          this.providers.push(this.user.npi);
        }
        
        console.log('🔍 Dashboard setPresets for Provider:');
        console.log('  - insChoice:', this.insChoice);
        console.log('  - groupChoice:', this.groupChoice);
        console.log('  - providers:', this.providers);
        console.log('  - location:', this.location);
        console.log('  - user.group (original):', this.user.group);
        console.log('  - user.location (original):', this.user.location);
      } else if (this.user.role === 'Specialist') {
        this.insChoice = this.user.insurance && this.user.insurance[0] ? this.user.insurance[0] : '';
        if (this.user.npi) {
          this.providers.push(this.user.npi);
        }
        console.log('🔍 Dashboard setPresets for Specialist:');
        console.log('  - insChoice:', this.insChoice);
        console.log('  - providers (NPI):', this.providers);
      } else if (this.user.role === 'Group' || this.user.role === 'Affiliation') {
        this.orgChoice = this.user.organization;
        this.insChoice = this.user.insurance[0];
      } else {
        this.orgChoice = this.user.organization;
        this.insChoice = this.user.insurance[0];
      }
    },
    async getDashboard() {
      this.loading = true;
      const { insChoice } = this;
      const { groupChoice } = this;
      const { locChoice } = this;
      const { startDate } = this;
      const { endDate } = this;
      
      // Para Provider, usar this.providers (com NPI) ao invés de provChoice
      const providers = (this.user.role === 'Provider' || this.user.role === 'Specialist') 
        ? this.providers 
        : this.provChoice;

      console.log('🔍 getDashboard called with:');
      console.log('  - insChoice:', insChoice);
      console.log('  - groupChoice:', groupChoice);
      console.log('  - locChoice:', locChoice);
      console.log('  - providers (from provChoice):', this.provChoice);
      console.log('  - providers (from this.providers):', this.providers);
      console.log('  - providers (final):', providers);
      console.log('  - startDate:', startDate);
      console.log('  - endDate:', endDate);

      const getAllData = async () => {
        try {
          // Detectar se é Provider do FamilyHealthChoice
          const isFHCProvider = (this.user.role === 'Provider' || this.user.role === 'Specialist') && 
                                 this.user.insurance && 
                                 this.user.insurance.some(ins => ins === 'FamilyHealthChoice' || ins === 'FloridaHealthChoice');
          
          if (isFHCProvider) {
            console.log('📊 FamilyHealthChoice Provider - Loading simplified dashboard (Membership only)');
            
            // Para FHC, usar rota simplificada e rápida
            const membershipUrl = `api/membership-simple/simple/${insChoice}`;
            console.log('🔍 Calling SIMPLE membership API:', membershipUrl);
            console.log('🔍 Parameters:');
            console.log('  - insChoice:', insChoice);
            
            const response = await axios.get(membershipUrl, { timeout: 60000 });
            console.log('✅ Membership API response:', response);
            console.log('✅ Response data type:', typeof response.data);
            console.log('✅ Response data:', response.data);
            
            // Configure simplified dashboard data
            let rawData = response.data.data || response.data;
            console.log('🔍 Raw data type:', typeof rawData);
            console.log('🔍 Is array?', Array.isArray(rawData));
            
            // Ensure it's an array
            if (!Array.isArray(rawData)) {
              console.log('⚠️ Data is not an array, converting...');
              rawData = rawData ? [rawData] : [];
            }
            
            this.membershipData = rawData;
            this.csvData = JSON.parse(JSON.stringify(this.membershipData));
            
            console.log('📊 Membership data configured:');
            console.log('  - membershipData type:', typeof this.membershipData);
            console.log('  - membershipData.length:', this.membershipData.length);
            console.log('  - csvData.length:', this.csvData.length);
            
            // Create Total Members card
            try {
              const avatarIcon = require('../assets/icons/avatar.svg');
              this.cards = [
                {
                  title: 'Total Members',
                  amount: this.membershipData.length || 0,
                  icon: avatarIcon
                }
              ];
              console.log('✅ Cards configured:', this.cards);
            } catch (iconError) {
              console.error('❌ Error loading icon:', iconError);
              // Use card without icon
              this.cards = [
                {
                  title: 'Total Members',
                  amount: this.membershipData.length || 0,
                  icon: ''
                }
              ];
            }
            
            this.loading = false;
            this.changeDetected = false;
            return; // Don't fetch claims/admissions data
          }
          
          // For other clients, fetch complete data
          console.log('📊 Loading full dashboard data...');
          
          // This is the chart data
          const url = `api/dashboard/groups=${groupChoice}/providers=${providers}/locs=${locChoice}/${insChoice}/${startDate}/${endDate}`;
          console.log('🔍 Calling dashboard API:', url);
          
          const dashData = await axios.get(url, { timeout: 30000 });
          console.log('✅ Dashboard data retrieved:', dashData.data);
          
          // This is the summary data for the cards above the charts
          const summaryUrl = `api/dashboard/summary/groups=${groupChoice}/providers=${providers}/locs=${locChoice}/${insChoice}/${startDate}/${endDate}`;
          console.log('🔍 Calling summary API:', summaryUrl);
          
          const summaryData = await axios.get(summaryUrl, { timeout: 30000 });
          console.log('✅ Summary data retrieved:', summaryData.data);
          
          // Membership data for the dashboard report
          const membershipUrl = `api/membership/${'membership'}/orgs=/groups=${this.groupChoice}/providers=${providers}/locations=/${insChoice}/${startDate}/${endDate}`;
          console.log('🔍 Calling membership API:', membershipUrl);
          
          const response = await axios.get(membershipUrl, { timeout: 30000 });
          console.log('✅ Membership data retrieved:', response.data);

          // this.membershipData = response.data.data;
          // this.csvData = JSON.parse(JSON.stringify(this.reportData));
          // this.csvData.forEach((obj) => {
          //   delete obj._id;
          //   delete obj.ID;
          // });
         //  const { result } = dashData.data;
         //  this.dashboardData = result;
         //  this.cancelSource = null;
         ///  this.erCost = dashData.data.erCost;
         //  this.erTotal = dashData.data.erTotal;
          this.admissionsCost = dashData.data.admissionsCost;
          console.log(this.admissionsCost);
          this.admissionsTotal = dashData.data.admissionsTotal;
          this.admissionsData = dashData.data.result; // Assign the data to admissionsData
          console.log('Admissions Data Updated:', this.admissionsData); // Log the updated data
          // this.brandRx = dashData.data.brandRx;
          // this.erCost = dashData.data.erCost;
          // this.erTotal = dashData.data.erTotal;
          // this.gdrAverage = dashData.data.gdrAverage;
          // this.revenueTotal = dashData.data.revenueTotal;
          // this.expensesTotal = dashData.data.expensesTotal;
          // this.brandRxCount = dashData.data.brandRxCount;
          // this.membership = dashData.data.membership;
          // this.allRxCount = dashData.data.allRxCount;
          // this.outpatientVisit = dashData.data.outpatientVisit;
          // this.outpatientCost = dashData.data.totalOutpatientCost;
          this.inpatients = dashData.data.inpatientTotal;
          // this.readmissions = dashData.data.readmits;

          this.loading = false;
          this.changeDetected = false;
        } catch (err) {
          this.loading = false; // Reset the loading state
          console.error('❌ Dashboard API Error:', err);
          console.error('❌ Error response:', err.response);
          console.error('❌ Error message:', err.message);
          console.error('❌ Error stack:', err.stack);
          
          // Show alert to user
          alert(`Error loading dashboard data: ${err.message}`);
        }
      };
      getAllData();
      this.close();
    },
    getOrgs() {
      axios.get('api/list/organization').then((response) => {
        this.organizations = response.data;
        this.orgChoice = this.organizations[0];
      });
    },
    async getLocations() {
      await axios.get(`api/selection/${this.provChoice}/locations`).then((response) => {
        this.locations = response.data[0].LOCATIONS;
        console.log(this.locations);
      });
    },
    async getProviders() {
      await axios.get(`api/selection/${this.groupChoice}/providers`).then((response) => {
        this.providers = response.data;
      });
    },
    getInsurances() {
      axios.get('api/list/insurances').then((response) => {
        this.insurances = response.data;
      });
    },
    async getGroups() {
      // Assigns entire user.group array if only one insurance, the else if is there in case there is more than one insurance and can only access certain groups within each insurance
      if (this.user.role === 'Group' && this.insurances.length === 1) {
        await axios.get(`api/list/npi/${this.user.npi}/groups`).then((response) => {
          this.groups = response.data;
          console.log(this.groups);
        });
      } else if (this.user.role === 'Group' && this.insurances.length > 1) {
        await axios.get(`api/list/${this.insChoice}/groups`).then((response) => {
          const userObjGroups = this.user.group;
          const allPossibleGroups = response.data;
          this.groups = [];
          allPossibleGroups.forEach((grp) => {
            if (userObjGroups.indexOf(grp) !== -1) {
              this.groups.push(grp);
            }
          });
        });
      } else if (this.insChoice.length > 1) {
        await axios.get(`api/list/${this.insChoice}/groups`).then((response) => {
          this.groups = response.data;
        });
      }
    },
    close() {
      this.menu = false;
    },
    formatCurrency(num) {
      const parsed = parseFloat(num);
      if (parsed === 0) {
        return '$0.00';
      }
      if (parsed != undefined && parsed != '') {
        return `$${parsed.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
      }
    },
    formatDate(date) {
      if (!date) return '';
      
      // Se for uma string de data ISO ou um objeto Date
      const d = new Date(date);
      
      // Verificar se é uma data válida
      if (isNaN(d.getTime())) return date;
      
      // Formatar no padrão americano MM/DD/YYYY
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();
      
      return `${month}/${day}/${year}`;
    },
    membershipName(item) {
      if (!item) return '—';
      const first = item.FIRST_NAME || item.MEMBER_FIRST_NAME || item.NAME_FIRST || '';
      const last = item.LAST_NAME || item.MEMBER_LAST_NAME || item.NAME_LAST || '';
      const combined = [last, first].filter(Boolean).join(', ');
      return combined || item.MEMBER_NAME || '—';
    },
  },
  computed: {
    filteredMembershipData() {
      if (!this.membershipData || !Array.isArray(this.membershipData)) return [];
      const term = (this.membershipSearch || '').trim().toLowerCase();
      if (!term) {
        return this.membershipData.map(item => ({ ...item, NAME: this.membershipName(item) }));
      }
      return this.membershipData
        .filter((item) => {
          const name = this.membershipName(item).toLowerCase();
          const id = String(item.SUBSCRIBER_ID || item._id || '').toLowerCase();
          return name.includes(term) || id.includes(term);
        })
        .map(item => ({ ...item, NAME: this.membershipName(item) }));
    },
    isFamilyHealthChoiceProvider() {
      const isProviderRole = this.user && (this.user.role === 'Provider' || this.user.role === 'Specialist');
      const hasInsurance = this.user && this.user.insurance && Array.isArray(this.user.insurance);
      const isFHC = hasInsurance && this.user.insurance.some(ins => {
        const insStr = String(ins).trim();
        return insStr === 'FamilyHealthChoice' || insStr === 'FloridaHealthChoice';
      });
      
      const result = isProviderRole && isFHC;
      
      console.log('🔍 isFamilyHealthChoiceProvider computed:');
      console.log('  - result:', result);
      console.log('  - user:', this.user);
      console.log('  - user.role:', this.user ? this.user.role : 'undefined');
      console.log('  - user.insurance:', this.user ? this.user.insurance : 'undefined');
      console.log('  - isProviderRole:', isProviderRole);
      console.log('  - hasInsurance:', hasInsurance);
      console.log('  - isFHC:', isFHC);
      
      return result;
    }
  },
  mounted() {
    this.getUser();
  },
  watch: {
    async insChoice() {
      this.groupChoice = [];
      this.provChoice = [];
      this.locChoice = [];
      if (this.showReport) {
        this.changeDetected = true;
      }

      if (
        this.user.role === 'Admin'
        || this.user.role === 'Superuser'
        || this.user.role === 'Group'
        || this.user.role === 'Affiliation'
      ) {
        if (this.insChoice !== []) {
          this.getGroups();
        }
      } else {
        this.insurances = this.user.insurance;

        if (this.user.role === 'Provider') {
          this.groupChoice = this.user.group;
        }
      }
    },
  },
};
</script>

<style scoped>
.export-button {
  position: absolute;
  left: 15px;
  bottom: 30px;
}
.show-filters {
  border-radius: 25% 0% 0% 25%;
  position: fixed;
  right: 0;
  z-index: 1;
  /* margin-top: 5.5rem; */
}
.membership-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}
.membership-table >>> .v-data-table td,
.membership-table >>> .v-data-table th {
  padding: 8px 16px !important;
}
</style>
